import Script from 'next/script';

const SPUR_MONOCLE_PUBLISHABLE_KEY =
  'l86xin0X6IjxbSFCXC9jzP9YzIzyT5mH3koPnjFdEZIzL1jL2oc4nHO0pLQGPclc4lLdN2kiltry545qbOKcM6sB5lR0N095laZOm15cfJCRH1IlN4ugIx6mmUcTHAaeezKMk2W0zZHIxFTbJcv9Sykp43aNt3eNcsOhY8EAGQrEWzQ85ciuVhdlO2Zpc27EW3JdDjJ6CCurSpd3XKp8bfSXsizJWEcafZtZeqN9zRTWFeqjn6rnUNOjl4w8dFkNGzEfG8B0mMD4gTYTkBukkfZRYQdzaP7Xar5hfn9vhDXxU6hCBR2cXraLiRMc4C7efS0Udd1daskEa8P04v5fuyc2ZRu5BjqInBpv7eqZh9LhYL6fUIqyt1uFnQ6QXTa9xFTfsvaj1jFtp0irtO1JHByil3uHdhx3kGHj2k75LjypX4DDVCFe8e';

type OwnProps = {
  enabled: boolean;
};

export default function SpurMonocleScript({ enabled }: OwnProps) {
  if (!enabled) return null;

  return (
    <Script
      async
      id="_mcl"
      src={`https://js.mcl.io/d/mcl.js?tk=${SPUR_MONOCLE_PUBLISHABLE_KEY}`}
      strategy="afterInteractive"
    />
  );
}
